// extracted by mini-css-extract-plugin
module.exports = {"motivator":"Motivator_motivator__t4jz_"};